import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { SalesByBatch } from "@models/batch-sales-report";
import { TableModule } from "primeng/table";

@Component({
    selector: "app-batches-report-table",
    imports: [TableModule],
    templateUrl: "./batches-report-table.component.html",
    styleUrl: "./batches-report-table.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BatchesReportTableComponent {
  @Input() batches: SalesByBatch[] = [];

  batchSoldTickets(index: number): number {
    return this.batches[index].tickets.reduce(
      (total, ticket) => total + ticket.quantity_sold,
      0,
    );
  }

  batchTotalTickets(index: number): number {
    return this.batches[index].tickets.reduce(
      (total, ticket) =>
        total + ticket.quantity_available + ticket.quantity_sold,
      0,
    );
  }

  getStatus(batch: SalesByBatch) {
    const today = new Date();
    const saleStart = new Date(batch.sale_start);
    const saleEnd = new Date(batch.sale_end);

    if (today < saleStart) {
      return "Aguardando";
    } else if (today >= saleStart && today < saleEnd) {
      // Verificar se ainda há tickets disponíveis
      const hasAvailableTickets = batch.tickets.some(
        (ticket) => ticket.quantity_available > 0,
      );
      return hasAvailableTickets ? "Vendendo" : "Esgotado";
    } else {
      return "Encerrado";
    }
  }
}
